import { type AxiosResponse } from 'axios';
import { type SourceModel } from 'configs/types';
import { type DynamicResult } from 'modules/dynamic-service';
import { dynamicNamespace, equals, mergeFilters } from 'utils/dynamic';
import {
  API,
  apiRtk,
  rtkAdapterDynamicItem,
  rtkAdapterDynamicToSource,
  rtkAdapterError,
} from 'utils/service';
import { type ITenant } from '__generated__/api';

const dynamic = dynamicNamespace<ITenant>();

type TenantCountry = { country: string; countryID: string };
export const apiTenants = apiRtk.injectEndpoints({
  endpoints: (build) => ({
    getSourceTenants: build.query<Array<SourceModel>, void>({
      queryFn: async () => {
        try {
          const response = await API.api.tenantsGetAllDynamicCreate({
            select: dynamic.select('id', 'companyName as title', 'isActive'),
            filter: mergeFilters(dynamic.makeFilter('isActive', true, equals)).join('&&'),
            orderBy: dynamic.orderBy('companyName', 'asc'),
          });
          return rtkAdapterDynamicToSource(
            response as unknown as AxiosResponse<DynamicResult<SourceModel>>,
          );
        } catch (e: any) {
          return { error: e };
        }
      },
    }),
    getTenantCountry: build.query<TenantCountry, string>({
      queryFn: async (tenantID) => {
        try {
          const response = await API.api.tenantsGetAllDynamicCreate({
            select: dynamic.select('country.countryName as country, country.id as countryID'),
            filter: mergeFilters(
              dynamic.makeFilter('isActive', true, equals),
              dynamic.makeFilter('id', tenantID, equals),
            ).join('&&'),
            take: 1,
          });
          return rtkAdapterDynamicItem(
            response as unknown as AxiosResponse<DynamicResult<TenantCountry>>,
          );
        } catch (e: any) {
          return rtkAdapterError(e);
        }
      },
    }),
  }),
});
